export const TASK_TYPE = {
  TIME: 1, // 时间段
  DATE: 2 // 日期
}

export const TIME_TYPE = {
  TIME_RANGE: 1, // 选择时间段
  ALL_DAY: 2 // 全天投放
}

export const DATE_POS = {
  START: 1, // 开始时间
  END: 2 // 结束时间
}

export const DATE_TYPE = {
  SPECIFY_DATE: 1, // 选择日期
  LONG_TERM: 2 // 长期投放
}

export const ALL_DAYS_SCHEDULE = Array.from({ length: 336 }, () => '1').join('')
export const KUAISHOU_ALL_DAYS_SCHEDULE = Array.from({ length: 168 }, () => '1').join('')
